import React from 'react';

import styled from '@emotion/styled';

import { tableFormatDateNG } from '../../../utils/utils';

interface TripLogCellProps {
  data?: any;
  moreOptionsComponents?: React.ReactNode[];
}

const TripLogCell: React.FC<TripLogCellProps> = ({
  data,
  moreOptionsComponents,
}) => {
  return (
    <Container>
      <FirstRow>
        <FirstRowLeftItems>
          <FirstText> {data?.driverName}</FirstText>
        </FirstRowLeftItems>
      </FirstRow>
      <DateRow>{tableFormatDateNG(data?.createdAt)}</DateRow>
      <SecondRow>{data?.customerEmail}</SecondRow>
      <DateRow>Date of trip: {tableFormatDateNG(data?.dateOfTrip)}</DateRow>
    </Container>
  );
};

export default TripLogCell;

const Container = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  border-radius: 5px;
  color: ${({ theme }) => theme.palette.grayTextColor};
  margin-bottom: 12px;
  font-size: 14px;
`;

const FirstRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.logirateBlack};
  display: flex;
  position: relative;
  /* g */
`;

const FirstRowLeftItems = styled.div`
  gap: 12px;
  align-items: center;
  margin-right: 18px;
  display: grid;
  grid-auto-flow: column;
  overflow: auto;

  /* Hide scroll bar */
  &::-webkit-scrollbar {
    display: none;
  }

  & > * {
    white-space: nowrap;
  }
`;

const FirstText = styled.div`
  display: flex;
`;

const SecondRow = styled.div`
  /* font-size: 14px; */
`;

const DateRow = styled.div`
  /* border: 1px solid ${({ theme }) => theme.palette.borderColor}; */
`;
